export const commonColors: any = {
  magenta: {
    0: '#fad2e3',
    1: '#f8a8cc',
    2: '#f37fb7',
    3: '#e0529c',
    4: '#cb2b83',
    5: '#a02669',
    6: '#75204f',
    7: '#551c3b',
    8: '#40162f',
    9: '#291321',
  },
  lime: {
    0: '#f0fab5',
    1: '#e4f88b',
    2: '#c9e75d',
    3: '#a9d134',
    4: '#8bbb11',
    5: '#6f9412',
    6: '#536d13',
    7: '#3e4f13',
    8: '#2e3c10',
    9: '#1f2611',
  },
  greekblue: {
    0: '#d2e0fa',
    1: '#a8c1f8',
    2: '#7f9ef3',
    3: '#5273e0',
    4: '#2b4acb',
    5: '#263ea0',
    6: '#203175',
    7: '#1c2755',
    8: '#161d40',
    9: '#131629',
  },
  blue: {
    0: '#EDFAFF',
    1: '#C7F1FF',
    2: '#73D8FC',
    3: '#1DBBF0',
    4: '#11ACEE',
    5: '#019DE5',
    6: '#0A8DD2',
    7: '#087ABB',
    8: '#055492',
    9: '#055492',
  },
  grey: {
    0: '#ffffff',
    1: '#fafafa',
    2: '#f5f5f5',
    3: '#f0f0f0',
    4: '#d9d9d9',
    5: '#bfbfbf',
    6: '#8c8c8c',
    7: '#595959',
    8: '#434343',
    9: '#262626',
    10: '#1f1f1f',
    11: '#141414',
    12: '#000000',
  },

};

export const commonColorsArrObj = Object.keys(commonColors).reduce((acc: any, item: any) => {
  const obj: any = {};
  obj[item] = Object.values(commonColors[item]);
  return { ...acc, ...obj };
}, {});

export const dark = {
  text: {
    primary: '',
    secondary: '',
    disabled: '',
    success: '',
    error: '',
    info: '',
    warning: '',
    link: '',
    button: '',
  },
  bg: {
    primary: '',
    secondary: '',
    disabled: '',
    success: '',
    error: '',
    info: '',
    warning: '',
  },
};
